import React from 'react'
import { motion, AnimatePresence } from 'motion/react'
import PrimaryNavigationBar from 'src/layouts/components/PrimaryNavigationBar'
import useNavigation from 'src/lib/hooks/useNavigation'
import SecondaryNavigationBar from 'src/layouts/components/SecondaryNavigationBar'
import { classNames } from 'src/lib/utils/helpers'

const NavigationBar = () => {
  const {
    getters: { sidebarOpen, isTablet, journeyStep }
  } = useNavigation()

  return (
    <div
      className={classNames('relative flex h-full py-2 scrollbar-hide w-full', isTablet ? 'w-auto' : '')}
      id='navigation-bar'
    >
      <div className='flex-shrink-0 pl-2 pr-1 z-10 overflow-hidden'>
        <PrimaryNavigationBar />
      </div>

      <AnimatePresence mode='wait'>
        {!sidebarOpen && !isTablet && (
          <motion.aside
            className='absolute top-2 left-16 z-12 flex w-[245px] max-h-[calc(100%-1rem)] min-h-0 origin-left flex-col'
            initial={{ opacity: 0, x: -50, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -50, scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 400, damping: 40 }}
          >
            <div className='flex min-h-0 w-full flex-1 flex-col overflow-hidden'>
              <SecondaryNavigationBar journeyStep={journeyStep} />
            </div>
          </motion.aside>
        )}
      </AnimatePresence>
    </div>
  )
}

export default NavigationBar
